import 'readmore-js';
import 'sticky-kit/dist/sticky-kit';
import { viewport, isBlogId, navText } from "../../functions";


$(function () {
    if (!$('body').hasClass('single-listing')) return;

    // image gallery carousel
    function reinitCarousels() {

        if (viewport().width < 768) {
            const owl = $('.images-gallery').owlCarousel({
                loop: false,
                dots: isBlogId(2),
                nav: isBlogId(1),
                items: 1,
                navText: navText('#637381'),
            });
            owl.on('changed.owl.carousel', function (e) {
                if (e.item) {
                    $('.carousel-index').text(e.relatedTarget.relative(e.relatedTarget.current()) + 1);
                }
            });

            const vfOwl = $('.vf-images-gallery');
            vfOwl.trigger('destroy.owl.carousel');
        }

        if (viewport().width >= 768) {
            const vfOwl = $('.vf-images-gallery').owlCarousel({
                loop: false,
                dots: false,
                nav: true,
                items: 3,
                navText: navText('#637381'),
            });

            const owl = $('.images-gallery');
            owl.trigger('destroy.owl.carousel');
        }
    }

    reinitCarousels();

    $(window).resize(function () {
        reinitCarousels();
    });

    // read more for description
    function generateReadMore() {
        const desc = $('.page-description');
        desc.readmore('destroy');
        desc.readmore({
            speed: 75,
            collapsedHeight: 116,
            moreLink: `<a class="morelink" href="#">${desc.attr('data-more-text')}</a>`,
            lessLink: `<a class="lesslink" href="#">${desc.attr('data-less-text')}</a>`,
        });
    }

    generateReadMore();
    $(window).resize(function () {
        generateReadMore();
    });

    // to make form sticky (float)
    if (viewport().width >= 992) {
        $('.form').stick_in_parent({
            inner_scrolling: true,
            offset_top: 80,
        });
    }

    $(window).on('resize', function () {
        if (viewport().width >= 992) {
            $('body').css({ overflow: 'unset' });
            $('.formColumn').show();
            $(document.body).trigger('sticky_kit:recalc');
        } else {
            $('body').css({ overflow: 'unset' });
            $('.formColumn').hide();
            $('.form').trigger("sticky_kit:detach");
        }
    });

    // form
    $('[href="#room-enquiry"]').click(function (e) {
        e.preventDefault();
        $('body').css({ overflow: 'hidden' });
        $('.formColumn').show();
        $('.form').addClass('active');
    });

    $('.close-form').click(function (e) {
        e.preventDefault();
        $('body').css({ overflow: 'unset' });
        $('.formColumn').hide();
        $('.form').removeClass('active');
    });
});
